function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var IS_BROWSER = typeof window !== 'undefined' && typeof window.document !== 'undefined';
var WINDOW = IS_BROWSER ? window : {};
var IS_TOUCH_DEVICE = IS_BROWSER ? 'ontouchstart' in WINDOW.document.documentElement : false;
var HAS_POINTER_EVENT = IS_BROWSER ? 'PointerEvent' in WINDOW : false;
var NAMESPACE = 'cropper';
var CROPPER_CANVAS = "".concat(NAMESPACE, "-canvas");
var CROPPER_CROSSHAIR = "".concat(NAMESPACE, "-crosshair");
var CROPPER_GIRD = "".concat(NAMESPACE, "-grid");
var CROPPER_HANDLE = "".concat(NAMESPACE, "-handle");
var CROPPER_IMAGE = "".concat(NAMESPACE, "-image");
var CROPPER_SELECTION = "".concat(NAMESPACE, "-selection");
var CROPPER_SHADE = "".concat(NAMESPACE, "-shade");
var CROPPER_VIEWER = "".concat(NAMESPACE, "-viewer"); // Actions

var ACTION_SELECT = 'select';
var ACTION_MOVE = 'move';
var ACTION_SCALE = 'scale';
var ACTION_ROTATE = 'rotate';
var ACTION_TRANSFORM = 'transform';
var ACTION_NONE = 'none';
var ACTION_RESIZE_NORTH = 'n-resize';
var ACTION_RESIZE_EAST = 'e-resize';
var ACTION_RESIZE_SOUTH = 's-resize';
var ACTION_RESIZE_WEST = 'w-resize';
var ACTION_RESIZE_NORTHEAST = 'ne-resize';
var ACTION_RESIZE_NORTHWEST = 'nw-resize';
var ACTION_RESIZE_SOUTHEAST = 'se-resize';
var ACTION_RESIZE_SOUTHWEST = 'sw-resize'; // Attributes

var ATTRIBUTE_ACTION = 'action'; // Native events

var EVENT_TOUCH_END = IS_TOUCH_DEVICE ? 'touchend touchcancel' : 'mouseup';
var EVENT_TOUCH_MOVE = IS_TOUCH_DEVICE ? 'touchmove' : 'mousemove';
var EVENT_TOUCH_START = IS_TOUCH_DEVICE ? 'touchstart' : 'mousedown';
var EVENT_POINTER_DOWN = HAS_POINTER_EVENT ? 'pointerdown' : EVENT_TOUCH_START;
var EVENT_POINTER_MOVE = HAS_POINTER_EVENT ? 'pointermove' : EVENT_TOUCH_MOVE;
var EVENT_POINTER_UP = HAS_POINTER_EVENT ? 'pointerup pointercancel' : EVENT_TOUCH_END;
var EVENT_ERROR = 'error';
var EVENT_KEYDOWN = 'keydown';
var EVENT_LOAD = 'load';
var EVENT_RESIZE = 'resize';
var EVENT_WHEEL = 'wheel'; // Custom events

var EVENT_ACTION = 'action';
var EVENT_ACTION_END = 'actionend';
var EVENT_ACTION_MOVE = 'actionmove';
var EVENT_ACTION_START = 'actionstart';
var EVENT_CHANGE = 'change';
var EVENT_TRANSFORM = 'transform';
/**
 * Check if the given value is a string.
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if the given value is a string, else `false`.
 */

function isString(value) {
  return typeof value === 'string';
}
/**
 * Check if the given value is not a number.
 */


var isNaN = Number.isNaN || WINDOW.isNaN;
/**
 * Check if the given value is a number.
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if the given value is a number, else `false`.
 */

function isNumber(value) {
  return typeof value === 'number' && !isNaN(value);
}
/**
 * Check if the given value is a positive number.
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if the given value is a positive number, else `false`.
 */


function isPositiveNumber(value) {
  return isNumber(value) && value > 0 && value < Infinity;
}
/**
 * Check if the given value is undefined.
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if the given value is undefined, else `false`.
 */


function isUndefined(value) {
  return typeof value === 'undefined';
}
/**
 * Check if the given value is an object.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is an object, else `false`.
 */


function isObject(value) {
  return _typeof(value) === 'object' && value !== null;
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * Check if the given value is a plain object.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is a plain object, else `false`.
 */

function isPlainObject(value) {
  if (!isObject(value)) {
    return false;
  }

  try {
    var _constructor = value.constructor;
    var prototype = _constructor.prototype;
    return _constructor && prototype && hasOwnProperty.call(prototype, 'isPrototypeOf');
  } catch (error) {
    return false;
  }
}
/**
 * Check if the given value is a function.
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if the given value is a function, else `false`.
 */


function isFunction(value) {
  return typeof value === 'function';
}
/**
 * Check if the given node is an element.
 * @param {*} node The node to check.
 * @returns {boolean} Returns `true` if the given node is an element; otherwise, `false`.
 */


function isElement(node) {
  return _typeof(node) === 'object' && node !== null && node.nodeType === 1;
}

var REGEXP_CAMEL_CASE = /([a-z\d])([A-Z])/g;
/**
 * Transform the given string from camelCase to kebab-case.
 * @param {string} value The value to transform.
 * @returns {string} Returns the transformed value.
 */

function toKebabCase(value) {
  return String(value).replace(REGEXP_CAMEL_CASE, '$1-$2').toLowerCase();
}

var REGEXP_KEBAB_CASE = /-[A-z\d]/g;
/**
 * Transform the given string from kebab-case to camelCase.
 * @param {string} value The value to transform.
 * @returns {string} Returns the transformed value.
 */

function toCamelCase(value) {
  return value.replace(REGEXP_KEBAB_CASE, function (substring) {
    return substring.slice(1).toUpperCase();
  });
}

var REGEXP_SPACES = /\s\s*/;
/**
 * Remove event listener from the event target.
 * {@link https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener}
 * @param {EventTarget} target The target of the event.
 * @param {string} types The types of the event.
 * @param {EventListenerOrEventListenerObject} listener The listener of the event.
 * @param {EventListenerOptions} [options] The options specify characteristics about the event listener.
 */

function off(target, types, listener, options) {
  types.trim().split(REGEXP_SPACES).forEach(function (type) {
    target.removeEventListener(type, listener, options);
  });
}
/**
 * Add event listener to the event target.
 * {@link https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener}
 * @param {EventTarget} target The target of the event.
 * @param {string} types The types of the event.
 * @param {EventListenerOrEventListenerObject} listener The listener of the event.
 * @param {AddEventListenerOptions} [options] The options specify characteristics about the event listener.
 */


function on(target, types, listener, options) {
  types.trim().split(REGEXP_SPACES).forEach(function (type) {
    target.addEventListener(type, listener, options);
  });
}
/**
 * Add once event listener to the event target.
 * @param {EventTarget} target The target of the event.
 * @param {string} types The types of the event.
 * @param {EventListenerOrEventListenerObject} listener The listener of the event.
 * @param {AddEventListenerOptions} [options] The options specify characteristics about the event listener.
 */


function once(target, types, listener, options) {
  on(target, types, listener, Object.assign(Object.assign({}, options), {
    once: true
  }));
}

var defaultEventOptions = {
  bubbles: true,
  cancelable: true,
  composed: true
};
/**
 * Dispatch event on the event target.
 * {@link https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/dispatchEvent}
 * @param {EventTarget} target The target of the event.
 * @param {string} type The name of the event.
 * @param {*} [detail] The data passed when initializing the event.
 * @param {CustomEventInit} [options] The other event options.
 * @returns {boolean} Returns the result value.
 */

function emit(target, type, detail, options) {
  return target.dispatchEvent(new CustomEvent(type, Object.assign(Object.assign(Object.assign({}, defaultEventOptions), {
    detail: detail
  }), options)));
}
/**
 * Get the real event target by checking composed path.
 * This is useful when dealing with events that can cross shadow DOM boundaries.
 * {@link https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath}
 * @param {Event} event The event object.
 * @returns {EventTarget | null} The first element in the composed path, or the original event target.
 */


function getComposedPathTarget(event) {
  if (typeof event.composedPath === 'function') {
    var path = event.composedPath();
    return path.find(isElement) || event.target;
  }

  return event.target;
}

var resolvedPromise = Promise.resolve();
/**
 * Defers the callback to be executed after the next DOM update cycle.
 * @param {*} [context] The `this` context.
 * @param {Function} [callback] The callback to execute after the next DOM update cycle.
 * @returns {Promise} A promise that resolves to nothing.
 */

function nextTick(context, callback) {
  return callback ? resolvedPromise.then(context ? callback.bind(context) : callback) : resolvedPromise;
}
/**
 * Get the root document node.
 * @param {Element} element The target element.
 * @returns {Document|DocumentFragment|null} The document node.
 */


function getRootDocument(element) {
  var rootNode = element.getRootNode();

  switch (rootNode.nodeType) {
    case 1:
      return rootNode.ownerDocument;

    case 9:
      return rootNode;

    case 11:
      return rootNode;
  }

  return null;
}
/**
 * Get the offset base on the document.
 * @param {Element} element The target element.
 * @returns {object} The offset data.
 */


function getOffset(element) {
  var documentElement = element.ownerDocument.documentElement;
  var box = element.getBoundingClientRect();
  return {
    left: box.left + (WINDOW.pageXOffset - documentElement.clientLeft),
    top: box.top + (WINDOW.pageYOffset - documentElement.clientTop)
  };
}

var REGEXP_ANGLE_UNIT = /deg|g?rad|turn$/i;
/**
 * Convert an angle to a radian number.
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/angle}
 * @param {number|string} angle The angle to convert.
 * @returns {number} Returns the radian number.
 */

function toAngleInRadian(angle) {
  var value = parseFloat(angle) || 0;

  if (value !== 0) {
    var _ref = String(angle).match(REGEXP_ANGLE_UNIT) || [],
        _ref2 = _slicedToArray(_ref, 1),
        _ref2$ = _ref2[0],
        unit = _ref2$ === void 0 ? 'rad' : _ref2$;

    switch (unit.toLowerCase()) {
      case 'deg':
        return value / 360 * (Math.PI * 2);

      case 'grad':
        return value / 400 * (Math.PI * 2);

      case 'turn':
        return value * (Math.PI * 2);
    }
  }

  return value;
}

var SIZE_ADJUSTMENT_TYPE_CONTAIN = 'contain';
var SIZE_ADJUSTMENT_TYPE_COVER = 'cover';
/**
 * Get the max sizes in a rectangle under the given aspect ratio.
 * @param {object} data The original sizes.
 * @param {string} [type] The adjust type.
 * @returns {object} Returns the result sizes.
 */

function getAdjustedSizes(data) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SIZE_ADJUSTMENT_TYPE_CONTAIN;
  var aspectRatio = data.aspectRatio;
  var width = data.width,
      height = data.height;
  var isValidWidth = isPositiveNumber(width);
  var isValidHeight = isPositiveNumber(height);

  if (isValidWidth && isValidHeight) {
    var adjustedWidth = height * aspectRatio;

    if (type === SIZE_ADJUSTMENT_TYPE_CONTAIN && adjustedWidth > width || type === SIZE_ADJUSTMENT_TYPE_COVER && adjustedWidth < width) {
      height = width / aspectRatio;
    } else {
      width = height * aspectRatio;
    }
  } else if (isValidWidth) {
    height = width / aspectRatio;
  } else if (isValidHeight) {
    width = height * aspectRatio;
  }

  return {
    width: width,
    height: height
  };
}
/**
 * Multiply multiple matrices.
 * @param {Array} matrix The first matrix.
 * @param {Array} args The rest matrices.
 * @returns {Array} Returns the result matrix.
 */


function multiplyMatrices(matrix) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (args.length === 0) {
    return matrix;
  }

  var _matrix = matrix,
      _matrix2 = _slicedToArray(_matrix, 6),
      a1 = _matrix2[0],
      b1 = _matrix2[1],
      c1 = _matrix2[2],
      d1 = _matrix2[3],
      e1 = _matrix2[4],
      f1 = _matrix2[5];

  var _args$ = _slicedToArray(args[0], 6),
      a2 = _args$[0],
      b2 = _args$[1],
      c2 = _args$[2],
      d2 = _args$[3],
      e2 = _args$[4],
      f2 = _args$[5]; // ┌ a1 c1 e1 ┐   ┌ a2 c2 e2 ┐
  // │ b1 d1 f1 │ × │ b2 d2 f2 │
  // └ 0  0  1  ┘   └ 0  0  1  ┘


  matrix = [a1 * a2 + c1 * b2
  /* + e1 * 0 */
  , b1 * a2 + d1 * b2
  /* + f1 * 0 */
  , a1 * c2 + c1 * d2
  /* + e1 * 0 */
  , b1 * c2 + d1 * d2
  /* + f1 * 0 */
  , a1 * e2 + c1 * f2 + e1
  /* * 1 */
  , b1 * e2 + d1 * f2 + f1
  /* * 1 */
  ];
  return multiplyMatrices.apply(void 0, [matrix].concat(_toConsumableArray(args.slice(1))));
}

export { ACTION_MOVE, ACTION_NONE, ACTION_RESIZE_EAST, ACTION_RESIZE_NORTH, ACTION_RESIZE_NORTHEAST, ACTION_RESIZE_NORTHWEST, ACTION_RESIZE_SOUTH, ACTION_RESIZE_SOUTHEAST, ACTION_RESIZE_SOUTHWEST, ACTION_RESIZE_WEST, ACTION_ROTATE, ACTION_SCALE, ACTION_SELECT, ACTION_TRANSFORM, ATTRIBUTE_ACTION, CROPPER_CANVAS, CROPPER_CROSSHAIR, CROPPER_GIRD, CROPPER_HANDLE, CROPPER_IMAGE, CROPPER_SELECTION, CROPPER_SHADE, CROPPER_VIEWER, EVENT_ACTION, EVENT_ACTION_END, EVENT_ACTION_MOVE, EVENT_ACTION_START, EVENT_CHANGE, EVENT_ERROR, EVENT_KEYDOWN, EVENT_LOAD, EVENT_POINTER_DOWN, EVENT_POINTER_MOVE, EVENT_POINTER_UP, EVENT_RESIZE, EVENT_TOUCH_END, EVENT_TOUCH_MOVE, EVENT_TOUCH_START, EVENT_TRANSFORM, EVENT_WHEEL, HAS_POINTER_EVENT, IS_BROWSER, IS_TOUCH_DEVICE, NAMESPACE, WINDOW, emit, getAdjustedSizes, getComposedPathTarget, getOffset, getRootDocument, isElement, isFunction, isNaN, isNumber, isObject, isPlainObject, isPositiveNumber, isString, isUndefined, multiplyMatrices, nextTick, off, on, once, toAngleInRadian, toCamelCase, toKebabCase };